import { useState } from "react";
import Templates from "components/templates/templatesList";
import Questions from "containers/questions";
import { Button } from "react-bootstrap";

const Index = () => {
  const [activeView, setActiveView] = useState("templates");

  return (
    <>
      <div className="d-flex justify-content-start mt-3 ms-5">
        <Button
          className={`primary-btn me-2 ${
            activeView === "templates" ? "primary-btn" : "secondary-btn"
          }`}
          onClick={() => setActiveView("templates")}
        >
          Templates
        </Button>
        <Button
          className={`primary-btn ${
            activeView === "questions" ? "primary-btn" : "secondary-btn"
          }`}
          onClick={() => setActiveView("questions")}
        >
          Questions
        </Button>
      </div>

      <div className="main-contents mt-4">
        <h1 className="heading-h5">
          {activeView === "questions" ? "Questions" : "Templates"}
        </h1>
        {activeView === "questions" ? <Questions /> : <Templates />}
      </div>
    </>
  );
};

export default Index;
